import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Register from "../../../Images/register.png";
import AddDeatils from "../../../Images/addDeatils.png";
import StartTrading from "../../../Images/startTrading.png";
import "./HowToStart.css";
function HowToStart() {
  return (
    <>
      <section className="how-start">
        <Container>
          <Row>
            <Col md={12}>
              <h1>How to start trading with Moneysukh?</h1>
            </Col>
            <Col md={4} sm={4}>
              <div className="each-how-start">
                <img className="img-fluid" src={Register} alt={Register} />
                <h3>
                  01<small>Register</small>
                </h3>
              </div>
            </Col>
            <Col md={4} sm={4}>
              <div className="each-how-start">
                <img className="img-fluid" src={AddDeatils} alt={AddDeatils} />
                <h3>
                  02<small>Add your details</small>
                </h3>
              </div>
            </Col>
            <Col md={4} sm={4}>
              <div className="each-how-start">
                <img className="img-fluid" src={Register} alt={Register} />
                <h3>
                  03<small>Start Trading</small>
                </h3>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default HowToStart;
